<template>
  <div class="form-container">
    <h3 class="text-center">enterprise {{enterprise.enterpriseId}}</h3>
    <ConfirmedAction
        :entity-id="enterprise.enterpriseId"
        :skip-first-step="true"
        info-text="Do you want to delete this enterprise?"
        button-label="Delete enterprise"
        button-icon="trash-alt"
        confirm-text="Please confirm you want to delete this enterprise by typing its full enterprise id below. You can copy and paste it from the previous page."
        confirm-help="The enterprise to delete"
        success-message=""
        error-message=""
        @action-confirmed="deleteItem()"
        @action-cancelled="cancel()"
      />
  
    <Error :label="error"/>
    <Success :label="success"/>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import { Enterprise } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';

interface Props {
  enterprise: Enterprise;
}

const props = withDefaults(defineProps<Props>(), {
  enterprise: () => ({}) as Enterprise
});

const emit = defineEmits<{
  cancel: [];
}>();

const router = useRouter();

const error = ref<string>('');
const success = ref<string>('');

const apiClient: ApiClient = curApiClient;

const deleteItem = async () => {
  const reply = await apiClient.deleteEnterprise(props.enterprise.enterpriseId);
  
  if(reply.httpCode === 403)
    return router.push({name:'login'});

  if(reply.errorMsg)
    return error.value = `Unable to delete enterprise: ${reply.errorMsg}`;
  
  setSuccess(`Enterprise ${props.enterprise.enterpriseId} has been deleted`);
};

const setSuccess = (str: string) => {
  success.value = str;
  setTimeout(() => emit('cancel'), 1000);
};

const cancel = () => {
  emit('cancel');
};
</script>

<style scoped lang="scss">

</style>